import { render } from "./ProjectRespondensDashboardView.vue?vue&type=template&id=3a49835a&scoped=true&ts=true"
import script from "./ProjectRespondensDashboardView.vue?vue&type=script&lang=ts"
export * from "./ProjectRespondensDashboardView.vue?vue&type=script&lang=ts"

import "./ProjectRespondensDashboardView.vue?vue&type=style&index=0&id=3a49835a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a49835a"]])

export default __exports__